import React from "react";
import { Container } from "reactstrap";
import { Check, Repeat, X } from "react-feather";

import rawHtml from 'html-react-parser';


const GameModal = ({selectedGame})=> {

  return (
    <Container className="game-modal">
      <div>
        <img src={selectedGame.icon}  />
        <p className="modal-game-name"> {selectedGame.name } </p>

        <table className="overlay-modal-table">
          <thead>
            <tr>
              <th> Target Score </th>
              <th> Reward </th>
              <th> Reached </th>
            </tr>
          </thead>
          <tbody>
            { selectedGame.actionsRewardsList?.map((reward, index)=> (
              <tr key={index}>
                <td>
                  { reward.action === 0 && <span className="text-muted">Install and run the game</span> }
                  { reward.action === 1 && <span> { reward.score } </span> }
                  { reward.action === 2 && <span> Every { reward.level } levels complete </span> }
                  { reward.action === 3 && <span> Play games for { reward.timeSpent } seconds </span> }
                </td>
                <td> { reward.reward } Points</td>
                <td> { reward.claimed === undefined ? 
                <Repeat /> 
                : reward.claimed ? 
                  <Check style={{color: "green"}} /> 
                  :
                  reward.action === 3 ?
                    <div>{reward.gamozeCounter +'/'+ reward.limit}</div>
                    :
                    <X style={{color: "brown"}} /> }</td>
              </tr>
            ))}
          </tbody>
        </table>
        <a href={selectedGame.link} target="_blank" className="btn go-to-game"> Start Game </a>
        <div className="description"> { rawHtml(selectedGame.description || '') } </div>
      </div>
    </Container>
  );
}

export default GameModal;
